




import { defineComponent } from "@vue/composition-api";
import { mapActions, mapGetters } from "vuex";
import { tableHeaders } from "@monorepo/utils/src/variables/projectsData/akView/tableHeaders";
import ToggleTableCells from "@monorepo/uikit/src/components/tableViews/ToggleTableCells.vue";
import { viewUniqKey } from "@monorepo/utils/src/variables/projectsData/akView/viewTitle";

export default defineComponent({
  name: "ToggleTableCellsContainer",
  components: {
    ToggleTableCells,
  },
  data() {
    return {
      viewUniqKey,
      tableHeaders,
    };
  },
  computed: {
    ...mapGetters("akView", ["cells"]),
  },
  methods: {
    ...mapActions("akView", ["setCells"]),
  },
});
